import { Injectable, Inject, PLATFORM_ID } from '@angular/core'
import { isPlatformBrowser } from '@angular/common'

interface LoadedScript {
  src: string
  loaded: boolean
}

@Injectable({ providedIn: 'root' })
export class ScriptLoaderService {
  private loadedScripts: { [key: string]: LoadedScript } = {}

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  loadScripts(scripts: string[]): Promise<void[]> {
    if (!isPlatformBrowser(this.platformId)) {
      return Promise.resolve([]) // SSR pe skip
    }
    return Promise.all(scripts.map(src => this.loadScript(src)))
  }

  private loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.loadedScripts[src]?.loaded) {
        resolve()
        return
      }
      const script = document.createElement('script')
      script.src = src
      script.async = false // order maintain karne ke liye
      script.onload = () => {
        this.loadedScripts[src] = { src, loaded: true }
        resolve()
      }
      script.onerror = () => reject(new Error(`Script load failed: ${src}`))
      document.body.appendChild(script)
    })
  }

  loadStyle(href: string): void {
    if (!isPlatformBrowser(this.platformId)) return
    if (document.querySelector(`link[href="${href}"]`)) return
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = href
    document.head.appendChild(link)
  }

  loadStyles(hrefs: string[]): void {
    hrefs.forEach(href => this.loadStyle(href))
  }
}
